import isClient from "./isClient";

const hasAbortController: () => boolean = () => isClient() && typeof window.AbortController !== "undefined";

export default hasAbortController;
